import { getCountries } from 'libphonenumber-js';
import countryNamesPl from 'react-phone-input-2/lang/pl.json';

// libphonenumber extras that are not ISO 3166-1 alpha-2 — backend rejects them
const NON_ISO_COUNTRY_CODES = new Set(['AC', 'TA']);

export interface Country {
  code: string;
  name: string;
  flag: string;
}

// Convert country code to flag emoji
export const countryToFlag = (countryCode: string): string => {
  return countryCode
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
};

export const getCountryName = (code: string): string =>
  (countryNamesPl as Record<string, string>)[code.toLowerCase()] ?? code;

export const preferredCountryCodes = ['PL', 'DE', 'GB', 'US', 'FR'];

export const countries: Country[] = getCountries()
  .filter((code) => !NON_ISO_COUNTRY_CODES.has(code))
  .map((code) => ({
    code,
    name: getCountryName(code),
    flag: countryToFlag(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name, 'pl'));
